import { AxiosResponse } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { NotificationTypeEnum } from './me-notification-preferences-service.types'

export const updateNotificationPreferences = async (notificationType: NotificationTypeEnum): Promise<AxiosResponse> => {
  const response = await axios.put(
    apiEndpoints.ME_PREFERENCES,
    {
      schedule_notification_type: notificationType
    })

  return response
}